const config = Object.freeze({
  AUTH_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:5001/fast-pdf-creator/us-central1/app/auth/' : 'https://phit.fastpdfcreator.com/auth/',
  API_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:5001/fast-pdf-creator/us-central1/app/api/' : 'https://phit.fastpdfcreator.com/api/',
  HUBSPOT_API_URL: 'https://api.hubapi.com/crm/v3',
});

export default config;
